
export const croAppsflyerLink = 'https://ovenbreak.onelink.me/657050516/73a8c62c';
